// extracted by mini-css-extract-plugin
module.exports = {"cards":"n_cj","cardBig":"n_ck","resources":"n_7","sectionTitle":"n_8"};